module.exports = __webpack_public_path__ + "static/media/Pro.a65a4cf4.svg";